import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "config" };
const _hoisted_2 = { class: "main-header" };
const _hoisted_3 = { class: "section-title" };
const _hoisted_4 = { class: "config__content" };
import { ref } from 'vue';
import Navigation from "@astina/paloma-common-ui/src/components/Navigation.vue";
import Icon from "@astina/paloma-common-ui/src/components/Icon.vue";
import { isGranted } from '@astina/paloma-common-ui/src/services/AccessManager';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ConfigView',
    setup(__props) {
        const tabItems = ref([]);
        if (isGranted('PORTAL_USERS_MANAGE')) {
            tabItems.value.push({ name: 'config_users' });
        }
        if (isGranted('PORTAL_NOTIFICATIONS_MANAGE')) {
            tabItems.value.push({ name: 'config_notifications' });
        }
        return (_ctx, _cache) => {
            const _component_router_view = _resolveComponent("router-view");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("header", _hoisted_2, [
                    _createElementVNode("h1", _hoisted_3, [
                        _createVNode(Icon, { name: "config" }),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('nav.config')), 1)
                    ]),
                    _cache[0] || (_cache[0] = _createTextVNode()),
                    _createVNode(Navigation, {
                        items: tabItems.value,
                        type: "content"
                    }, null, 8, ["items"])
                ]),
                _cache[1] || (_cache[1] = _createTextVNode()),
                _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_router_view)
                ])
            ]));
        };
    }
});
